import { EpModal, hideModal } from '../EpModal';
import { useTranslation as t } from '../../hooks/useTranslation';
import styles from './EpModalTimeout.module.scss';
import { EpIcon } from '../EpIcon';
import { EpButton } from '../EpButton';
import { signinSilent, signoutRedirect, signoutWithoutRedirect } from '../../services/authService';
import { useEffect, useState } from 'react';
import { useAuthStore } from '../../stores/useAuthStore';

interface IEpModalTimeout {
  modalId: string;
  translations: unknown;
}

export const EpModalTimeout = ({
  translations,
  modalId,
}: IEpModalTimeout) => {
  const [counter, setCounter] = useState(0);
  const { isActivity, setOpenModalTimeout } = useAuthStore();

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isActivity && counter > 0) {
        setCounter(counter - 1);
      };
    }, 1000);

    return () => clearInterval(interval);
  }, [counter, isActivity]);

  useEffect(() => {
    if (!isActivity && counter <= 0) {
      signoutWithoutRedirect();
    }
  }, [counter, isActivity]);

  return (
    <EpModal
      customClasses={styles['custom-modal']}
      modalId={modalId}
      modalTitle={t(translations, 'Closed session')}
      modalType="danger"
      modalFooter={null}
      hasCloseBtn={false}
      ModalPreventBackdropClose={true}
    >
      <div className={styles['content']}>
        <div className={styles['content__timer']}>
          <EpIcon
            iconName="RegularClock"
            iconSize={64}
            customClasses={styles['content__icon']}
          />
        </div>

        {counter <= 0 ? (
          <div className={styles['content__flex']}>
            <p className={styles['content__text']}>{t(translations, 'Your session has ended, please log in again to access the system.')}</p>

            <div>
              <EpButton buttonOnClickFunc={() => signoutRedirect()} buttonType={'primary-outline'} buttonText={t(translations, 'Login')} buttonLeftIconName='SolidCheck' />
            </div>
          </div>
        ) : (
          <div className={styles['content__flex']}>
            <p className={styles['content__text--neutral-dark']}>
              {t(translations, 'Are you there?')}
            </p>

            <p className={styles['content__text']}>
              {t(translations, 'Your session will close in')}
            </p>

            <p className={styles['content__text--lg']}>
              {counter} <span className={styles['content__text--sm']}>{t(translations, 'Seconds')}</span>
            </p>

            <div className={styles['content__btn-flex']}>
              <EpButton
                buttonOnClickFunc={() => signoutRedirect(true)}
                buttonType={'secondary-outline'}
                buttonText={t(translations, 'Log out')}
                buttonLeftIconName='SolidCheck'
              />

              <EpButton
                buttonOnClickFunc={() => {
                  signinSilent();
                  setOpenModalTimeout(false);
                  hideModal(modalId);
                }}
                buttonType={'primary'}
                buttonText={t(translations, 'Stay connected')}
                buttonLeftIconName='SolidCheck'
              />
            </div>
          </div>
        )}
      </div>
    </EpModal>
  );
};
